import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  content: {
    maxHeight: '50vh',
    padding: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3),
    },
  },
  contentDividers: {
    borderBottom: theme.customBorders.gray200,
    borderTop: theme.customBorders.gray200,
  },
}));

export default useStyles;
